import { Pipe, PipeTransform } from '@angular/core';

const REGACY_SERVER_DATE_REGEX = /^(\d{4})\-(\d{2})\-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;

@Pipe({
  name: 'toDate',
})
export class ToDatePipe implements PipeTransform {
  transform(value: any, args?: any): Date {
    if (!value) {
      return value;
    }

    // 2020-12-08 01:22:40 같은 이전 형식의 date string 처리
    if (REGACY_SERVER_DATE_REGEX.test(value)) {
      const params = REGACY_SERVER_DATE_REGEX.exec(value).reduce(
        (result, dateComp, index) => {
          if (index > 0) {
            result.push(parseInt(dateComp) + (index === 2 ? -1 : 0));
          }

          return result;
        },
        []
      );
      value = Date.UTC.apply(null, params);
    }

    return new Date(value);
  }
}
